// Single source of truth for the DEV/QA card-add refusal injector. Each token,
// sent as Adyen paymentMethod.holderName on the TEST environment, forces the
// matching refusal resultCode from Adyen. Consumed by useAdyenCardAdd (the
// injection point), DevScreen (native selector), and the platform-forked
// getQaRefusalToken (web query param / native selection).

export type QaRefusalOption = {
  label: string;
  token: string | null;
};

export const QA_REFUSAL_NONE_VALUE = 'NONE';

export const QA_REFUSAL_OPTIONS: readonly QaRefusalOption[] = [
  { label: 'None (off)', token: null },
  { label: 'Refused', token: 'DECLINED' },
  { label: 'Blocked card', token: 'BLOCK_CARD' },
  { label: 'Expired card', token: 'CARD_EXPIRED' },
  { label: 'Invalid amount', token: 'INVALID_AMOUNT' },
  { label: 'Invalid card number', token: 'INVALID_CARD_NUMBER' },
  { label: 'Issuer unavailable', token: 'ISSUER_UNAVAILABLE' },
  { label: 'Not supported', token: 'NOT_SUPPORTED' },
  { label: 'Not enough balance', token: 'NOT_ENOUGH_BALANCE' },
  { label: '3DS not authenticated', token: 'NOT_3D_AUTHENTICATED' },
  { label: 'Referral', token: 'REFERRAL' },
  { label: 'Acquirer error', token: 'ERROR' },
  { label: 'Pending', token: 'PENDING' },
];

const QA_REFUSAL_TOKENS: ReadonlySet<string> = new Set(
  QA_REFUSAL_OPTIONS.map((option) => option.token).filter(
    (token): token is string => token !== null
  )
);

export const isQaRefusalToken = (
  value: string | null | undefined
): value is string => typeof value === 'string' && QA_REFUSAL_TOKENS.has(value);
